import type { OnChanges, SimpleChanges } from '@angular/core';
import { ChangeDetectionStrategy, Component, output, inject, input } from '@angular/core';

import { CL_EMPTY_STATE_I18N, type CLEmptyStateI18n } from '@core/cover-letter-types';
import { TranslatePipe } from '@core/i18n-legacy';
import { ButtonComponent, EmptyStateComponent, IconComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-cover-letter-empty-state',
  templateUrl: './cover-letter-empty-state.component.html',
  styleUrls: ['./cover-letter-empty-state.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [EmptyStateComponent, TranslatePipe, ButtonComponent, IconComponent],
})
export class CoverLetterEmptyStateComponent implements OnChanges {
  public readonly i18n = inject<CLEmptyStateI18n>(CL_EMPTY_STATE_I18N);

  public readonly supportEnabled = input(false);

  public readonly downloadEnabled = input(false);

  public supportClick = output<void>();

  public downloadClick = output<void>();

  public ngOnChanges(changes: SimpleChanges): void {
    if (
      (this.supportEnabled() && !this.i18n.support?.length) ||
      (this.downloadEnabled() && !this.i18n.download?.length)
    ) {
      console.warn('Warning! Optional input enabled, but translation value has not been provided!');
    }
  }
}
